/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-process-io-parameters .mat-tab-label{flex-grow:1}ui-process-io-parameters .mat-tab-label-content{display:flex;line-height:24px}ui-process-io-parameters .mat-tab-label-content mat-icon{margin-right:5px;line-height:inherit!important}"];
export { styles as styles };
